var _g, _g2, _path, _g3, _path2, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogomark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_245_29557)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.1429,
    cy: 44.2856,
    r: 12.8571,
    fill: "url(#paint0_linear_245_29557)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_245_29557)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.0001,
    cy: 64.2858,
    rx: 12.8571,
    ry: 11.4286,
    fill: "#6E11B0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 11.4285H22.8573L28.5716 19.9999L22.8573 22.857L20.0001 11.4285Z",
    fill: "url(#paint1_linear_245_29557)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_245_29557)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.4286,
    cy: 9.99993,
    r: 5.71429,
    fill: "url(#paint2_linear_245_29557)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 11.4285H57.1429L51.4286 19.9999L57.1429 22.857L60 11.4285Z",
    fill: "url(#paint3_linear_245_29557)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_245_29557)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.71429,
    cy: 5.71429,
    r: 5.71429,
    transform: "matrix(-1 0 0 1 64.2858 4.28564)",
    fill: "url(#paint4_linear_245_29557)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_245_29557)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62.8571,
    cy: 44.2856,
    r: 12.8571,
    fill: "url(#paint5_linear_245_29557)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_245_29557)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0932 17.1256C39.6977 17.1131 40.3023 17.1131 40.9068 17.1256C45.4369 17.2189 49.956 18.0125 54.2997 19.5056C63.6929 22.7346 69.9999 31.572 70 41.5047V45.9676C69.9998 53.3352 66.0747 59.5649 60.3976 63.0156C56.0419 66.4914 50.5231 68.5709 44.5173 68.5709H35.4827C29.4765 68.5709 23.9569 66.4918 19.601 63.0156C13.9245 59.5647 10.0002 53.3348 10 45.9676V41.5047C10.0001 31.572 16.3071 22.7346 25.7003 19.5056C30.044 18.0125 34.5631 17.2189 39.0932 17.1256Z",
    fill: "url(#paint6_linear_245_29557)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ddi_245_29557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 41.5044C17.1429 34.6214 21.5133 28.4977 28.0225 26.2602C35.7847 23.592 44.2155 23.592 51.9777 26.2602C58.4869 28.4977 62.8572 34.6214 62.8572 41.5044V45.9676C62.8572 54.4461 54.7603 60.5799 46.5984 58.2844C42.2832 57.0708 37.7169 57.0708 33.4018 58.2844C25.2399 60.5799 17.1429 54.4461 17.1429 45.9676V41.5044Z",
    fill: "url(#paint7_linear_245_29557)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_245_29557)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.4287,
    cy: 42.8571,
    rx: 4.28571,
    ry: 5.71429,
    fill: "url(#paint8_linear_245_29557)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_245_29557)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5715,
    cy: 42.8571,
    rx: 4.28571,
    ry: 5.71429,
    fill: "url(#paint9_linear_245_29557)"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_245_29557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.9089 64.6568C62.6245 63.5947 63.5961 62.6228 64.6584 62.9074L75.4271 65.7938C76.4893 66.0784 76.8463 67.406 76.0688 68.1836L74.0041 70.2469L78.1559 74.4001C78.7135 74.958 78.7137 75.8624 78.1559 76.4202L76.4204 78.1543C75.8624 78.7119 74.9581 78.7121 74.4003 78.1543L70.2485 74.0025L68.1838 76.0672C67.4062 76.8441 66.0789 76.4885 65.794 75.4269L62.9089 64.6568Z",
    fill: "url(#paint10_linear_245_29557)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_245_29557",
    x: 4.28577,
    y: 29.9999,
    width: 28.5714,
    height: 27.1429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.85714,
    dy: -1.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.635294 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_245_29557"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_245_29557",
    x: 27.1429,
    y: 51.4286,
    width: 28.5714,
    height: 25.7143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.1429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.714286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_245_29557"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.85714,
    dy: -1.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.635294 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_245_29557",
    result: "effect2_innerShadow_245_29557"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_245_29557",
    x: 14.2858,
    y: 4.28564,
    width: 12.8572,
    height: 12.857,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 11.4286,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_245_29557"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.71429
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.635294 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_245_29557"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.42857,
    dy: 1.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.42857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "effect1_innerShadow_245_29557",
    result: "effect2_innerShadow_245_29557"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_245_29557",
    x: 51.4286,
    y: 4.28564,
    width: 12.8572,
    height: 12.857,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 11.4286,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_245_29557"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.71429
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.635294 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_245_29557"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.42857,
    dy: 1.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.42857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "effect1_innerShadow_245_29557",
    result: "effect2_innerShadow_245_29557"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_245_29557",
    x: 48.5714,
    y: 31.4285,
    width: 27.1428,
    height: 27.1429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.42857,
    dy: 1.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.42857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_245_29557"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_245_29557",
    x: 8.57143,
    y: 15.6876,
    width: 64.2857,
    height: 54.3117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.85714,
    dy: -1.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.635294 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_245_29557"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.42857,
    dy: 1.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.42857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "effect1_innerShadow_245_29557",
    result: "effect2_innerShadow_245_29557"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ddi_245_29557",
    x: 15.2858,
    y: 20.9733,
    width: 49.4285,
    height: 41.0822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.928571
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_245_29557"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.928571
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "effect1_dropShadow_245_29557",
    result: "effect2_dropShadow_245_29557"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_245_29557",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.85714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.42857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_245_29557"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_245_29557",
    x: 40.1429,
    y: 30.1428,
    width: 22.5714,
    height: 25.4285,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.635294 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_245_29557"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_245_29557",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_245_29557",
    x: 17.2858,
    y: 30.1428,
    width: 22.5714,
    height: 25.4285,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.635294 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_245_29557"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_245_29557",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_245_29557",
    x: 61.4302,
    y: 62.8572,
    width: 17.1439,
    height: 17.1439,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.42857,
    dy: 1.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.42857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_245_29557"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_29557",
    x1: 30.0001,
    y1: 31.4417,
    x2: 1.04092,
    y2: 52.7286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C27AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E11B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_245_29557",
    x1: 28.5716,
    y1: 22.857,
    x2: 27.5656,
    y2: 12.4039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C27AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E11B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_245_29557",
    x1: 27.1429,
    y1: 4.29153,
    x2: 14.2722,
    y2: 13.7524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C27AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E11B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_245_29557",
    x1: 51.4286,
    y1: 22.857,
    x2: 52.4345,
    y2: 12.4039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C27AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E11B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_245_29557",
    x1: 0.00597878,
    y1: 0.00607344,
    x2: 9.46659,
    y2: 12.8765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C27AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E11B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_245_29557",
    x1: 75.7143,
    y1: 31.4417,
    x2: 46.7552,
    y2: 52.7286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C27AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E11B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_245_29557",
    x1: 70,
    y1: 17.1427,
    x2: 10,
    y2: 68.5713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C27AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E11B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_245_29557",
    x1: 62.8572,
    y1: 24.2855,
    x2: 17.1429,
    y2: 58.5713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8200DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996106,
    stopColor: "#3C0366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_245_29557",
    x1: 51.4287,
    y1: 37.1428,
    x2: 51.4287,
    y2: 48.5714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_245_29557",
    x1: 28.5715,
    y1: 37.1428,
    x2: 28.5715,
    y2: 48.5714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_245_29557",
    x1: 76.3861,
    y1: 65.8207,
    x2: 65.8214,
    y2: 76.3847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FD9A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomark);
export default __webpack_public_path__ + "static/media/Logomark.091d79827aba85e2d59a1403848edd95.svg";
export { ForwardRef as ReactComponent };